import React from 'react'
import { useTranslation } from 'react-i18next'

import SubscriptionDetail from 'adminDashboard/companySettings/subscription/components/SubscriptionDetail'
import { Col, Row } from 'antd'

import { CreditCardDetails } from 'core/application/adminDashboard/companySettings/subscription/subscriptionDetails'

interface ViewCreditCardInfoProps {
  paymentDetails: CreditCardDetails
}

const ViewCreditCardInfo: React.FC<ViewCreditCardInfoProps> = ({ paymentDetails }) => {
  const { t: translate } = useTranslation()
  return (
    <>
      <Row>
        <Col md={12}>
          <SubscriptionDetail
            title={translate('admin-dashboard.company-settings.subscription.cardholder-name')}
            description={`${paymentDetails.firstName} ${paymentDetails.lastName}`}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <SubscriptionDetail
            title={translate('admin-dashboard.company-settings.subscription.card-number')}
            description={`XXXX-XXXX-XXXX-${paymentDetails.cardNumberLastFour}`}
          />
        </Col>
        <Col md={12}>
          <SubscriptionDetail
            title={translate('admin-dashboard.company-settings.subscription.expiration-date')}
            description={`${paymentDetails.expirationMonth}/${paymentDetails.expirationYear}`}
          />
        </Col>
      </Row>
    </>
  )
}

export default ViewCreditCardInfo
